import { NgModule }               from '@angular/core';
import { FormsModule }            from '@angular/forms';
import { CommonModule }           from '@angular/common';
import { AppRoutingModule }       from '../app-routing.module';
import { NgxMyDatePickerModule }  from 'ngx-mydatepicker';
import { StatisticComponent } from './statistic.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    NgxMyDatePickerModule
  ],
  exports: [
    StatisticComponent
  ],
  declarations: [
    StatisticComponent
  ],
  providers: [  ]
})
export class StatisticModule {}



// WEBPACK FOOTER //
// ./src/app/statistic/statistic.module.ts